import { Component, Input, NgModule, inject } from '@angular/core';
import { ReportService } from '@src/app/features/reports/components/report-filters/services/report.service';
import { SectionedCommonReportDictionaryItem } from '@src/app/features/reports/components/report-filters/models/report-filters.model';
import { CommonModule, KeyValuePipe } from '@angular/common';
import { FormModule } from '@shared/components/form/form.module';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxGroupFilterComponentModule } from '@src/app/features/reports/components/report-filters/components/checkbox-group-filter/checkbox-group-filter.component';
import { CheckboxGroupFilterComponent } from '../checkbox-group-filter/checkbox-group-filter.component';

@Component({
  selector: 'stx-sectioned-checkbox-group-filter',
  templateUrl: './sectioned-checkbox-group-filter.component.html',
  imports: [CheckboxGroupFilterComponent, KeyValuePipe, TranslateModule]
})
export class SectionedCheckboxGroupFilterComponent<SECTION> {
  readonly reportService = inject(ReportService);

  @Input() enumValToTranslationLabel: Map<SECTION, string>;
  @Input() enumToDicMapping: SectionedCommonReportDictionaryItem;
  @Input() formGroupReferenceName: string;
  @Input() filterName: string;
}

@NgModule({
  imports: [CommonModule, FormModule, TranslateModule, CheckboxGroupFilterComponentModule, SectionedCheckboxGroupFilterComponent],
  exports: [SectionedCheckboxGroupFilterComponent]
})
export class SectionedCheckboxGroupFilterModule {}
